export default [
  /*{
    path: '/ingreso',
    component: () => import('@/views/Login.vue'),
    props: {
      template: 'complete'
    }
  },
  {
    path: "/registro",
    component: () => import('@/views/Register.vue'),
    props: {
      template: 'complete'
    }
  },
  {
    path: '/acerca-de',
    component: () => import('@/views/About.vue'),
    props: {
      template: 'complete'
    }
  },
  {
    path: '/ayuda',
    component: () => import('@/views/Help.vue'),
    props: {
      template: 'complete'
    }
  },*/
  {
    path: '/qr/:code',
    component: () => import('@/views/Qr.vue'),
    props: {
      template: 'complete'
    }
  },
  {
    path: '/portada',
    component: () => import('@/views/Portada.vue'),
    props: {
      template: 'portada-v2'
    }
  },
  {
    path: '/portada-test',
    component: () => import('@/views/PortadaTestAscenso.vue'),
    props: {
      template: 'portada-v2'
    }
  }
];
